import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';
import { Link } from 'core/routing';

import { Button, Spinner } from 'components';

export const RowStyle = styled.div`
  opacity: ${props => (props.faded ? '0.5' : '1')};
  width: 100%;
  height: ${props => (props.height ? props.height : '70px')};
  background-color: ${props =>
    props.highlighted ? props.theme.color.primary : props.theme.color.wfWhite};
  border-bottom: ${props =>
    props.onlyRow ? 'none' : `1px solid ${props.theme.color.wfGrey200}`};
  padding-right: 20px;
  position: relative;
  ${props =>
    props.last
      ? ' border-bottom-left-radius: 4px; border-bottom-right-radius: 4px; border-bottom: none'
      : ''};
  &:hover {
    background-color: ${props =>
      props.noColorChange
        ? props.theme.color.wfWhite
        : props.theme.color.wfGrey100};
  }
`;

export const OnlyRowStyle = styled(RowStyle)`
  margin-bottom: 10px;
  box-shadow: rgba(0, 0, 0, 0.4) 0 0 1px;
  border-bottom: none;
`;

export const RowNameInput = styled.div`
  position: relative;
  width: 325px;
  background-color: ${props => props.theme.color.wfGrey100};
  font-size: 1em;
  margin: 13px 0 0 0;
  padding: 2px 4px;
  display: block;
  color: ${props => props.theme.color.wfGrey900};
  border: 1px solid ${props => props.theme.color.wfGrey200};
  > input {
    width: 315px;
  }
  ${media.l`
    width: 285px;
    > input {
      width: 275px;
    }
  `}
`;

export const RepoColumn = styled.div`
  width: ${props => props.width};
  height: ${props => (props.slim ? '34px' : ' 70px')};
  float: left;
  ${props =>
    props.isFlex &&
    `
    display: flex;
    align-items: center;
    justify-content: start;
    `}
  ${props =>
    props.isFlex &&
    props.isFlexEnd &&
    `
    justify-content: flex-end;
    `}
`;

export const RepoColumnText = styled.h3`
  > a:nth-of-type(1) {
    &:hover {
      color: ${props =>
        props.isTitle ? props.theme.color.wfGrey : props.theme.color.primary};
      text-decoration: ${props => (props.isTitle ? 'none' : 'underline')};
      cursor: pointer;
    }
  }
  font-size: ${props => (props.isTitle ? '0.75em' : '1em')};
  color: ${props =>
    props.isTitle
      ? `${props.theme.color.wfBlack}`
      : `${props.theme.color.wfGrey900}`};
  margin: 0;
  font-weight: ${props => (props.isTitle ? '600' : 'normal')};
  display: inline-block;
`;

export const ActionsColumn = styled(RepoColumn)`
  float: right;
  padding-top: 18px;
  padding-right: 0;
  display: ${props => (props.renaming ? 'block' : 'none')};
  ${RowStyle}:hover & {
    display: block;
  }
  ${media.m`
    ${RowStyle}:hover & {
      display: ${props => (props.renaming ? 'block' : 'none')};
    }
  `}
`;

export const IconColumn = styled(RepoColumn)`
  width: 90px;
  ${media.m`
    width: 90px;
  `};
`;

export const DownloadButtonStyled = styled(Button)`
  float: right;
`;

export const FileInputWrapper = styled.div`
  &:hover {
    > div:nth-of-type(1) {
      color: ${props => props.theme.color.primary};
      border-color: ${props => props.theme.color.primary};
    }
  }
`;

export const InvisibleInput = styled.input`
  position: absolute;
  top: 0;
  right: 0;
  width: ${props => (props.size ? `${props.size}px;` : '75px;')};
  height: ${props => (props.size ? `${props.size}px;` : '40px;')};
  opacity: 0;
  cursor: pointer;
  z-index: 1;
`;

export const InputFileStyled = styled.input`
  display: none;
`;

export const DirLink = styled(Link)`
  font-size: ${props => (props.first ? '1.375em' : '1.125em')};
  font-weight: 600;
  color: ${props => props.theme.color.primary};
  line-height: 1.4;
  &:hover {
    text-decoration: underline;
  }
  ${media.s`
    font-size: 0.9em;
  `}
`;

export const DirName = styled.span`
  font-size: 1.125em;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.7);
  line-height: 1.4;
  ${media.s`
    font-size: 0.9em;
  `}
`;

export const ContribMode = styled.span`
  font-size: 1.125em;
  color: ${props => props.theme.color.wfGrey500};
  margin-left: 8px;
`;

/* TODO: replace SpinnerWrapper and RepoSpinner by Loading component */
const SpinnerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
`;
export const RepoSpinner = observer(() => (
  <SpinnerWrapper>
    <Spinner margin='100px 0' />
  </SpinnerWrapper>
));

export const ButtonsWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  /* TODO: Replace this way to distribute space without reference html tags once we can refactor this element  */
  > button,
  > a,
  > label {
    margin-left: ${props => props.theme.spacing.default};
  }
  ${media.xs`
    display: none;
  `};
`;

export const CommentsWrapper = styled.div`
  width: 700px;
  margin: 0 auto;
  ${media.m`
    width: 780px;
  `};
  ${media.s`
    width: 620px;
  `};
  ${media.xs`
    width: calc(100% - 30px);
  `};
`;

export const ButtonStyled = styled(Button)`
  margin-left: ${props => props.theme.spacing.small};
`;
